<template>
    <div :class="`story-maker-post-creator ${cursorName}`">

        <div class="overflow" :style="{backgroundColor : formData.storification.background.color}">
            <div v-if="!overlayMode" class="btns-action">

                <div class="btn text" @click="addText">
                    <img :src="require('../../../assets/img/instagram/icon_story_text.png')">
                </div>
                <div class="btn stickers" @click="setOverlay('stickers')">
                    <img :src="require('../../../assets/img/instagram/icon_story_sticker.png')">
                </div>
                <div class="btn music" @click="() => { musicSticker ? updateSticker(musicSticker.id, {isEditing : true}) : setOverlay('stickers-musicMenu')}">
                    <img v-if="musicSticker" class="thumbnail-music" :src="musicSticker.data.music.track.cover_artwork_thumbnail_uri">
                    <img v-else :src="require('../../../assets/img/instagram/icon_story_music.png')">
                </div>
            </div>
            <div v-else-if="overlayMode && (overlayMode.slice(0,8) == 'stickers' || overlayMode == 'backgroundResize')" class="btns-action">
                <div class="btn cancel" @click="closeOverlay">
                    <img :src="require('../../../assets/img/instagram/instagram_x_outline_44.png')">
                </div>
            </div>

            <div class="btn-background-resize" v-if="overlayMode == 'backgroundResize'">
                <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" style="transform: rotate(45deg);" @click="setSizeBackground('containX')"></i>
                <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center"  @click="setSizeBackground('cover')"></i>
                <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" style="transform: rotate(135deg);" @click="setSizeBackground('containY')"></i>
            </div>
            
            <div class="trash-stiker" v-if="onStickerDrag" @mouseover="trashIsHover = true" @mouseleave="trashIsHover = false" :class="{active : trashIsHover}">
                <div class="icon"></div>       
            </div>

            <div class="container-bg-story" :class="{edit:overlayMode == 'backgroundResize'}">
                <draggable 
                :position="formData.storification.background.position" 
                :transform="formData.storification.background.transform" 
                :classCustom="formData.storification.background.size"
                :disableTransform="overlayMode !== 'backgroundResize'" 
                :disableMove="overlayMode !== 'backgroundResize'" 
                @setStoryMakerCursor="setCursor"
            >
                <div class="bg-story selectDisable" :class="formData.storification.background.size">
                    <template v-if="formData.storification.background.file">
                        <img  v-if="['image/png','image/jpeg','image/gif'].includes(formData.storification.background.file.file.type)" class="selectDisable" :src="formData.storification.background.file.url"  draggable="false">
                        <video v-else-if="['video/mp4'].includes(formData.storification.background.file.file.type)"  muted loop playsinline preload="metadata" class="source" onloadedmetadata="true">
                            <source :src="formData.storification.background.file.url" type="video/mp4">
                        </video>
                    </template>  
                </div>
            </draggable>

            </div>
          
            <template v-if="overlayMode !== 'backgroundResize'" v-for="sticker in Object.values(formData.storification.stickers)">
                <draggable 
                    :position="sticker.position" 
                    :transform="sticker.transform" 
                    :disableTransform="sticker.disableTransform" 
                    :disableMove="sticker.disableMove" 
                    :zIndex="sticker.zIndex"
                    :trashIsHover="trashIsHover"
                    :classCustom="`story-maker-draggable-sticker ${sticker.type}`"
                    @setDragState="(state)=>{onStickerDrag = state; trashIsHover = false}"
                    @setStoryMakerCursor="setCursor"
                    @increaseZIndex="()=>increaseZIndexSticker(sticker.id)"
                    @deleteSticker="()=>deleteSticker(sticker.id)"
                >
                    <template v-slot="{ setCover, setCbClick, isPreventCover , isCover }">
                        <stickerWrapper
                            :sticker="sticker"
                            :isPreventCover="isPreventCover"
                            :isCover="isCover"
                            :setCover="setCover"
                            :setCbClick="setCbClick"
                            @updateSticker="updateSticker"
                            @deleteSticker="deleteSticker"
                        />
                    </template>
                </draggable>
            </template>

            <StickerMenu v-if="overlayMode && overlayMode.split('-')[0] == 'stickers'" :menuNameDefault="overlayMode.split('-')[1]" :dataInstagramDefault="dataInstagramDefault" @addSticker="addSticker" @updateSticker="updateSticker" @close="closeOverlay"/>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import StickerMenu from './storyMaker/stickerMenu/main.vue';
    import draggable from './storyMaker/draggable.vue';
    import stickerWrapper from './storyMaker/stiker/stickerWrapper.vue';
    import { stickerDataDefault } from './storyMaker/stickerMenu/main.vue';
    import minxinPost from '../../mixins/Posts.vue'

    export default {

        mixins: [minxinPost],
        components: {
            StickerMenu,
            draggable,
            stickerWrapper,  
        },

        props: {
            formData :  Object,
        },

        data() {
            return {
                zIndex: Math.max(0,...Object.values(this.formData.storification.stickers).map(s => s.zIndex)) + 1,
                overlayMode: false,
                cursorName: '',
                dataInstagramDefault: {},
                onStickerDrag: false,
                trashIsHover: false,
            }
        },

        mounted () {
            this.getDataInstagramDefault();
            EventBus.$on('storyMaker-setOverlay', this.setOverlay);
        },

        methods: {
            addSticker(sticker) {
                if (!sticker.id) sticker.id = Date.now()
                if (!sticker.zIndex) sticker.zIndex = ++this.zIndex
                this.$set(this.formData.storification.stickers, sticker.id, sticker)
            },

            updateSticker(id, payload) {
                this.$set(this.formData.storification.stickers, id, {
                    ...this.formData.storification.stickers[id],
                    ...payload
                })  
            },

            deleteSticker(id) {
                this.$delete(this.formData.storification.stickers, id)         
            },

            increaseZIndexSticker(id) {
                if (this.formData.storification.stickers[id].zIndex == this.zIndex) return
                this.$set(this.formData.storification.stickers, id, {
                    ...this.formData.storification.stickers[id],
                    zIndex: ++this.zIndex
                })
            },

            setCursor(cursorName) {
                this.cursorName = cursorName
            },

            setOverlay(name) {
                this.overlayMode = name
            },

            closeOverlay() { 
                this.overlayMode = false
            },

            async getDataInstagramDefault() {
                let page = this.pagesSelected.find(p => p.story_config && p.story_config.created) || this.allPages.find(p => p.story_config && p.story_config.created)
                
                const data = {}

                if (page) {
                    //GIF
                    try {
                        data.gifs = (await this.getTrendGifsInstagram(page.id)).body.gifs.results.giphy
                    } catch (error) {
                        data.gifs = []
                    }

                    //music
                    try {
                        data.musics = (await this.getMusicInstagram(page.id, "2024")).body.musics
                    } catch (error) {
                        data.musics = []
                    }

                    //localisation 
                    try {
                        data.localisations = (await this.getLocation(page.id, 'france')).body.locations
                    } catch (error) {
                        data.localisations = []
                    }

                    //shops
                    try {
                        data.shops = (await this.getTrendShopsInstagram(page.id)).body.shops
                    } catch (error) {
                        data.shops = []
                    }
                }

                this.dataInstagramDefault = data
                
                
                
            },
            
            addText() {
                this.addSticker({...JSON.parse(JSON.stringify(stickerDataDefault['text']))})
            },

            setSizeBackground(size) {

                this.$set(
                    this.formData.storification, 
                    'background', 
                    {   
                        ...this.formData.storification.background,
                        size : size,
                        position: {"x":50,"y":50},
                        transform: {"rotate":0,"scale":1}
                    }
                ) 

            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },
            musicSticker() {
                // Cherche directement le premier sticker de type 'music'
                return Object.values(this.formData.storification.stickers).find(sticker => sticker.type === 'music') || null;
            },

            
        },

        beforeDestroy () {
            EventBus.$off('storyMaker-setOverlay', this.setOverlay);
        }
    }
</script>

<style lang="scss" scoped>

</style>



